import {
  PLAYFIELD,
  COLLECTIBLE_TYPES,
} from '../core/Constants';

/**
 * Vaus Craft (Player Paddle) with Left/Right arrow movement and smoothed mouse tracking
 */
export class Paddle {
  constructor(difficulty) {
    this.baseWidth = difficulty.paddleWidth || 96;
    this.width = this.baseWidth;
    this.height = 14;
    this.y = PLAYFIELD.bottom - 32;
    this.x = (PLAYFIELD.left + PLAYFIELD.right) / 2 - this.width / 2;

    this.speed = 13.0; // Responsive keyboard speed for ArrowLeft / ArrowRight
    this.targetX = null;

    // Power-up States
    this.laserActive = false;
    this.catchActive = false;
    this.expandedActive = false;

    // Laser firing cooldowns
    this.lastLaserTime = 0;
    this.laserCooldown = 220; // ms
  }

  reset(difficulty) {
    this.baseWidth = difficulty.paddleWidth || 96;
    this.width = this.baseWidth;
    this.y = PLAYFIELD.bottom - 32;
    this.x = (PLAYFIELD.left + PLAYFIELD.right) / 2 - this.width / 2;
    this.laserActive = false;
    this.catchActive = false;
    this.expandedActive = false;
    this.targetX = null;
  }

  applyPowerup(type) {
    switch (type) {
      case COLLECTIBLE_TYPES.EXPAND:
        this.expandedActive = true;
        this.width = Math.min(this.baseWidth * 1.4, 160);
        this.clampBounds();
        break;

      case COLLECTIBLE_TYPES.LASER:
        this.laserActive = true;
        this.expandedActive = false;
        this.width = this.baseWidth;
        break;

      case COLLECTIBLE_TYPES.CATCH:
        this.catchActive = true;
        break;

      default:
        break;
    }
  }

  update(dt, input) {
    let movedByKeyboard = false;

    // Alternative movement method: Left and Right Arrow keys (plus A and D)
    if (input.isKeyDown('ArrowLeft') || input.isKeyDown('KeyA')) {
      this.x -= this.speed * dt * 60;
      movedByKeyboard = true;
    }
    if (input.isKeyDown('ArrowRight') || input.isKeyDown('KeyD')) {
      this.x += this.speed * dt * 60;
      movedByKeyboard = true;
    }

    // Mouse movement (only applied when keyboard is not currently actively moving the paddle)
    if (!movedByKeyboard) {
      if (input.isPointerLocked) {
        const delta = input.consumeMouseDeltaX();
        if (Math.abs(delta) < 80) {
          this.x += delta * input.mouseSensitivity;
        }
      } else if (input.mouseX !== null && input.hasMouseMoved) {
        // Direct cursor tracking: smooth 1:1 mapping
        const targetX = input.mouseX - this.width / 2;
        this.x = targetX;
      }
    }

    this.clampBounds();
  }

  clampBounds() {
    if (this.x < PLAYFIELD.left) {
      this.x = PLAYFIELD.left;
    }
    if (this.x + this.width > PLAYFIELD.right) {
      this.x = PLAYFIELD.right - this.width;
    }
  }

  canFireLaser(currentTime) {
    return this.laserActive && currentTime - this.lastLaserTime >= this.laserCooldown;
  }

  recordLaserFired(currentTime) {
    this.lastLaserTime = currentTime;
  }

  getBounds() {
    return {
      left: this.x,
      right: this.x + this.width,
      top: this.y,
      bottom: this.y + this.height,
    };
  }

  getHitOffset(ballX) {
    const center = this.x + this.width / 2;
    const offset = (ballX - center) / (this.width / 2);
    return Math.max(-1.0, Math.min(1.0, offset));
  }
}
